__turbopack_context__.v({
  "blok-big-title": "QuoteBlok-module__gX8EBq__blok-big-title",
  "blok-subtitle": "QuoteBlok-module__gX8EBq__blok-subtitle",
  "blok-title": "QuoteBlok-module__gX8EBq__blok-title",
  "center": "QuoteBlok-module__gX8EBq__center",
  "cta": "QuoteBlok-module__gX8EBq__cta",
  "right": "QuoteBlok-module__gX8EBq__right",
  "root": "QuoteBlok-module__gX8EBq__root",
  "tags": "QuoteBlok-module__gX8EBq__tags",
  "wrapper": "QuoteBlok-module__gX8EBq__wrapper",
});
